import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { authData } from "../../components/GetAuth";
import styles from "./permissionForm.module.css";

const AddPermissionForm = ({ setFormOpen, setSnackbarOpen, setSnackbarMessage, setSnackbarType, setLoading }) => {
    const auth = authData();
    const API_TOKEN = auth?.api_token;
    const [permissionList, setPermissionList] = useState([{ id: 0, name: 'No Category' }]);

    const { register, handleSubmit, control, formState: { errors } } = useForm({
        mode: 'onChange'
    });

    useEffect(() => {
        const fetchPerms = () => {
            axios.get(process.env.REACT_APP_API_URL + 'v1/user-permissions', {
                headers: {
                    Authorization: `Bearer ${API_TOKEN}`,
                }
            }).then(response => {
                let permList = response.data.data?.map(i => {
                    return { id: i?.id, name: i?.name };
                })
                setPermissionList([{ id: 0, name: 'No Category' }].concat(permList));
            });
        }

        fetchPerms();
    }, [API_TOKEN]);


    const onSubmit = (data) => {
        setLoading(true);
        setFormOpen(false);

        axios.post(process.env.REACT_APP_API_URL + 'v1/user-permissions', data, {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`,
            }
        }).then(response => {
            setLoading(false);
            if (response.data.status === 'SUCCESS') {
                setSnackbarOpen(true);
                setSnackbarMessage(response.data.message);
                setSnackbarType('success');
            }
            if (response.data.status === 'ERROR') {
                setSnackbarOpen(true);
                setSnackbarMessage(response.data.message);
                setSnackbarType('error');
            }
        }).catch(error => {
            setLoading(false);
            if (error && error.response && error.response.data && error.response.data.messages) {
                setSnackbarOpen(true);
                setSnackbarMessage(error.response.data.messages);
                setSnackbarType('error');
            }
        });
    }

    return (<>
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className={`${styles.FormRow}`}>
                <div className={`${styles.FormHalfGroup}`}>
                    <Controller
                        control={control}
                        {...register('name', { required: 'This field is Required' })}
                        render={({ field }) => <TextField {...field} label="Name*" variant="outlined" fullWidth />}
                    />
                    {errors.name && <span className={`${styles.ErrorM}`}>{errors?.name?.message}</span>}
                </div>
                <div className={`${styles.FormHalfGroup}`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Category*</InputLabel>
                        <Controller
                            control={control}
                            {...register('category')}
                            render={({ field }) =>
                                <Select label="Category*" {...field}>
                                    {permissionList?.map(i => {
                                        return (<MenuItem key={i?.id} value={i?.id}>{i?.name}</MenuItem>)
                                    })}
                                </Select>
                            }
                        />
                    </FormControl>
                </div>
            </div>
            <div className={`${styles.FormButtonArea}`}>
                <Button className={`${styles.CancelBU}`} onClick={(e) => setFormOpen(false)}>Cancel</Button>
                <Button className={`${styles.SubmitBU}`} type="submit">Add</Button>
            </div>
        </form>
    </>);
}

export default AddPermissionForm;